import { render, staticRenderFns } from "./SettingsCommunicationPanel.vue?vue&type=template&id=57430776"
import script from "./SettingsCommunicationPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsCommunicationPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports